export default {
    data() {
        return {
            bluezinho500: '#009ada',
            grayColor: '#999',
            dangerColor: '#f86c6b',
            warningColor: '#ffc107',
            successColor: '#4dbd74',
        }
    },
}
